import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import HelpText from '../__partials/help-text';
import Label from '../__partials/label';
import idGenerator from '../../__utils/idGenerator';

const Textarea = ({
  label,
  name,
  required,
  disabled,
  hasError,
  helpText,
  hideLabel,
  hasDivider,
  minHeight,
  className,
  qaId,
  textareaRef,
  ...props
}) => {
  let newName = name;

  if (!newName) {
    newName = idGenerator();
  }

  const textareaItemClasses = classNames('uni-form__item', 'l-grid__item', {
    'uni-form__item--is-error': hasError,
    'uni-form__item--is-disabled': disabled,
    'uni-form__item--has-divider': hasDivider,
    [className]: className,
  });

  return (
    <div className={textareaItemClasses}>
      <Label label={label} name={newName} required={required} hideLabel={hideLabel} />
      <div className="uni-form__control">
        <textarea
          className="uni-form__textarea"
          aria-describedby={newName + 'Help'}
          id={newName}
          disabled={disabled}
          style={{ minHeight: minHeight }}
          data-qa-id={qaId}
          ref={textareaRef}
          {...props}
        />
      </div>
      {helpText ? <HelpText name={newName} text={helpText} /> : null}
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  hideLabel: PropTypes.bool,
  hasDivider: PropTypes.bool,
  minHeight: PropTypes.string,
  className: PropTypes.string,
  qaId: PropTypes.string,
  textareaRef: PropTypes.func,
};

Textarea.defaultProps = {
  required: false,
  disabled: false,
  hasError: false,
  hideLabel: false,
  hasDivider: false,
};

export default Textarea;



// WEBPACK FOOTER //
// ./src/forms/textarea/index.jsx